"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Accordion = require("./Accordion");
var _flex = require("../../layout/flex");
var _FlexItem = require("../../layout/flex/FlexItem");
var _Label = _interopRequireDefault(require("../../text/Label"));
var _IconTooltip = _interopRequireDefault(require("../../feedback/tooltip/IconTooltip"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _accordion = require("./accordion.tokens");
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
var StyledEmptyAccordion = _styledComponents.default.div.withConfig({
  displayName: "EmptyAccordion__StyledEmptyAccordion",
  componentId: "sc-1fid717-0"
})(["display:flex;flex-grow:1;flex-direction:row;align-items:center;padding:", " ", ";background:", ";", ";border-radius:", ";height:", ";"], _tokens.default.sky.ref.unit["200"], _tokens.default.sky.ref.unit["600"], function (_ref) {
  var background = _ref.background;
  return background ? _accordion.tokens.background.default : 'none';
}, _accordion.tokens.border.background, function (_ref2) {
  var background = _ref2.background;
  return background ? _tokens.default.sky.ref.unit["100"] : 0;
}, _tokens.default.sky.ref.unit["1600"]);
var StyledLabelContent = _styledComponents.default.div.withConfig({
  displayName: "EmptyAccordion__StyledLabelContent",
  componentId: "sc-1fid717-1"
})(["display:flex;gap:", ";"], _tokens.default.sky.sys.spacing['100']);
var EmptyAccordion = function EmptyAccordion(_ref3) {
  var _ref3$background = _ref3.background,
    background = _ref3$background === void 0 ? true : _ref3$background,
    content = _ref3.content,
    label = _ref3.label,
    tooltip = _ref3.tooltip,
    contentAlignment = _ref3.contentAlignment;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledEmptyAccordion, {
    background: background,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_flex.FlexRow, {
      columnGap: 's',
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Accordion.ContentContainer, {
        stacked: false,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledLabelContent, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Label.default, {
            color: 'default',
            children: label
          }), tooltip && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconTooltip.default, {
            iconSize: 'm',
            children: tooltip
          })]
        }), content && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FlexItem.FlexItem, {
          flexGrow: '1',
          justifyContent: contentAlignment === _Accordion.Alignment.LEFT ? _flex.FLEX_ALIGN_ITEMS.START : _flex.FLEX_ALIGN_ITEMS.END,
          children: content
        })]
      })
    })
  });
};
var _default = exports.default = EmptyAccordion;